export function getApplicationByUrl() {
  return typeof document !== 'undefined' ? document.location.hostname.split('.')[0] : '';
}